export default __webpack_public_path__ + "static/media/loading.0f8e3ead.gif";